export default __webpack_public_path__ + "static/media/3.e086129c.svg";